import { EntryType } from '@models/account/model';

export function isRemittance(entryType: EntryType): boolean {
  return [ EntryType.ClientRemittanceDistribution, EntryType.PayeeRemittanceDistribution ].includes(entryType);
}

export function isFunding(entryType: EntryType): boolean {
  return [ EntryType.FundingSettlement, EntryType.ClientCABToCDAF ].includes(entryType);
}

export function isCDAFFunding(entryType: EntryType): boolean {
  return entryType === EntryType.ClientCABToCDAF;
}

export function isCDAFDisbursement(entryType: EntryType): boolean {
  return [ EntryType.CDAFDisbursementToClient, EntryType.CDAFAwardToParticipant ].includes(entryType);
}
